export default __webpack_public_path__ + "static/media/CocoGothicLight.1e754564.ttf";